import Status from "@/enum/Status";

type GetRequestsPayload = {
    limit: any;
    page: any;
    order: any;
    filters: object;
};

type GetRequestsResponse = {
    totalRows: number;
    data: any;
}

class RequestService {
    proxy: any;

    constructor(proxy: any) {
        this.proxy = proxy;
    }

    async editRequest(requestId: string, payload: any) {
        try {
            const response: any = await this.proxy.$root._put(`requests/editDetails/${requestId}`, payload);
            return response;
        } catch (e) {
            this.proxy.$root.notify('Error al editar la solicitud', 'error');
            throw e;
        }
    }

    async changeStatus(requestId: string, status: number, msg: string = null) {
        try {
            await this.proxy.$root._post(`requests/${requestId}/changestatus/${status}`, {
                status,
                rejectionReasonId: status === Status.No_Procesada ? 4 : null
            });
            msg && this.proxy.$root.notify(msg, 'success');
        } catch (e) {
            msg && this.proxy.$root.notify(msg, 'success');
        }
    };

    async preapproveRequest(requestId: string) {
        await this.changeStatus(requestId, Status.Preaprobado);
    }

    async processRequest(requestId: string) {
        await this.changeStatus(requestId, Status.Procesada, 'La solicitud se ha procesado con éxito');
        setTimeout(() => window.location.href = `/requests/bordereaux`, 1000);
    };

    async rejectRequest(requestId: string) {
        await this.changeStatus(requestId, Status.No_Procesada, 'La solicitud se ha declinado con éxito');
        setTimeout(() => window.location.href = `/requests/bordereaux`, 1000);
    };

    async quoteRequest(requestId: string, payload: any = null) {
        await this.preapproveRequest(requestId);
        payload && await this.editRequest(requestId, {
            ...payload,
            status: Status.Cotizado,
        });
        await this.changeStatus(requestId, Status.Cotizado, 'La solicitud se ha cotizado con éxito');
        setTimeout(() => window.location.href = `/requests/quotes`, 1000);
    };

    async getDictionary() {
        const response: any = await this.proxy.$root._get('requests/dictionary');
        return response;
    }

    async getRequests({ limit, page, order, filters }: GetRequestsPayload): Promise<GetRequestsResponse> {
        const payload = {
            limit: limit,
            page: page,
            order: order,
            models: 'companies',
            ...filters,
        };
        const response: any = await this.proxy.$root._post('requests/all', payload);
        return response;
    }
}

export default RequestService;